import { z } from "zod";

const checkoutTitles = ["mademoiselle", "madame", "monsieur"] as const;

export type CheckoutTitle = (typeof checkoutTitles)[number];

export const createCheckoutTitleSchema = (requiredError: string) =>
  z.enum(checkoutTitles, { required_error: requiredError });

const isCheckoutTitle = (value: unknown): value is CheckoutTitle =>
  typeof value === "string" && checkoutTitles.includes(value as CheckoutTitle);

export const resolveCheckoutTitle = (
  checkoutTitle: CheckoutTitle | undefined,
  profileTitle: unknown
): CheckoutTitle | undefined => checkoutTitle ?? (isCheckoutTitle(profileTitle) ? profileTitle : undefined);
